export default __webpack_public_path__ + "static/media/arrows-move.602183f4.svg";